import { cancelLocalTaxiScheduledRide } from './cancelLocalTaxiScheduledRide';
import { cancelScheduledRide } from './cancelScheduledRide';
import { cancelWillCallRide } from './cancelWillCallRide';
import { createLocalTaxiScheduledRide } from './createLocalTaxiScheduledRide';
import { createScheduledRide } from './createScheduledRide';
import { createStaWavScheduledRide } from './createStaWavScheduledRide';
import { createWillCallRide } from './createWillCallRide';
import { fetchPartnerScheduledRideCalendarRecords } from './fetchPartnerScheduledRideCalendarRecords';
import { fetchPartnerScheduledRideRecords } from './fetchPartnerScheduledRideRecords';
import { fetchScheduledRideCalendarRecords } from './fetchScheduledRideCalendarRecords';
import { fetchScheduledRideHistories } from './fetchScheduledRideHistories';
import { fetchScheduledRideRecords } from './fetchScheduledRideRecords';
import { fetchWillCallRideRecords } from './fetchWillCallRideRecords';
import { getCanceledRepeatedScheduledRidesDueToMembership } from './getCanceledRepeatedScheduledRidesDueToMembership';
import { getStaWavScheduledRideEstimation } from './getStaWavScheduledRideEstimation';
import { replaceStaWavScheduledRide } from './replaceStaWavScheduledRide';
import { restoreScheduledRide } from './restoreScheduledRide';
import { updateScheduledRide } from './updateScheduledRide';

export const scheduledRideService = {
  cancelLocalTaxiScheduledRide,
  cancelScheduledRide,
  cancelWillCallRide,
  createLocalTaxiScheduledRide,
  createScheduledRide,
  createWillCallRide,
  createStaWavScheduledRide,
  fetchPartnerScheduledRideCalendarRecords,
  fetchPartnerScheduledRideRecords,
  fetchScheduledRideCalendarRecords,
  fetchScheduledRideHistories,
  fetchScheduledRideRecords,
  fetchWillCallRideRecords,
  getCanceledRepeatedScheduledRidesDueToMembership,
  getStaWavScheduledRideEstimation,
  replaceStaWavScheduledRide,
  restoreScheduledRide,
  updateScheduledRide,
};
